module.exports = __webpack_public_path__ + "img/acaki3.1bb501cb.jpg";